import React, {Fragment,useRef} from 'react'
import { ApiHooks } from '../../../services/api';
import './css/_chat.scss'; 
 
export default function Chat() { 
    const { callKickBox, sendMessage } = ApiHooks();
    const input_name = useRef(null);
    const input_mail = useRef(null);
    const input_select= useRef(null);
    const input_text = useRef(null);
    const openChat = () => { 
        if (typeof document !== `undefined`) {
            document.getElementById("sis-email-button").style.display = "none";
            document.getElementById("email-assistant").style.display = "block";
        }
    }
    const closeChat = () => {
        if (typeof document !== `undefined`) {
            document.getElementById("sis-email-button").style.display = "block";
            document.getElementById("email-assistant").style.display = "none";
            document.getElementById("assistant-success").style.display = "none";
            document.getElementById("assistant-body").style.display = "block";
            clearForm()
        }
    }
    const validateForm = () => {
        let valid = true; 
        const emailRegex =  new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, "gm");
        const isValidEmail = emailRegex.test(input_mail.current.value);
        if (typeof document !== `undefined`) {
            if( input_name.current.value.length >= 21 || input_name.current.value.length === 0 ) {
                document.getElementById("assistant-name-error").style.display = "block"; 
                valid = false;
            }
            else {
                document.getElementById("assistant-name-error").style.display = "none";  
            }
            if( input_mail.current.value.length >= 46 || input_mail.current.value.length === 0 || !isValidEmail) {
                document.getElementById("assistant-email-error").style.display = "block"; 
                valid = false;
            }
            else {
                document.getElementById("assistant-email-error").style.display = "none";  
            }
            if( input_select.current.value.length >= 36 || input_select.current.value.length === 0) {
                document.getElementById("assistant-select-error").style.display = "block"; 
                valid = false;
            }
            else {
                document.getElementById("assistant-select-error").style.display = "none";  
            }
            if( input_text.current.value.length >= 201 || input_text.current.value.length === 0) {
                document.getElementById("assistant-text-error").style.display = "block"; 
                valid = false;
            }
            else {
                document.getElementById("assistant-text-error").style.display = "none";  
            }
            if(valid) {
                document.getElementById("email-loader-container").style.display = "block";
                document.getElementById("assistant-body").style.display = "none";
                checkKick(input_mail.current.value);
            } 
        }
        
    }
    const checkKick = (email) => {
        const results = callKickBox(email);
        results.then((response) => {
            if (response.data != null) {
 
                if(response.data.success === true) {
                    handleKickboxValidation(response.data.result, response.data.did_you_mean);
                } else { 
                    handleKickboxValidation("error", "error");
                }
 
            }
        })
        .catch(function (error) {
            console.log(error);
        })

    }

    const handleKickboxValidation = (result, dym) => {
        if (typeof document !== `undefined`) {
            if(result === "undeliverable") { // Email is not legit, stay here and show error
                    // Hide loader
                    document.getElementById("email-loader-container").style.display = "none";
                    document.getElementById("assistant-body").style.display = "block";
    
                    if(dym === null) {
                        document.getElementById("assistant-email-error").innerHTML = "Please enter a valid Email";
                    } else {
                        document.getElementById("assistant-email-error").innerHTML = "Did you mean"+dym;
                    }
                    
                    document.getElementById("assistant-email-error").style.display = "block";
    
                
            } 
            else { // Email is legit, send the email
                sendEmail();
            }
            
        }
    }

    const sendEmail = () => {
        const device = detectDevice();
        const data = {
            'name': input_name.current.value,
            'email': input_mail.current.value,
            'select': input_select.current.value,
            'text': input_text.current.value,
            'device': device,
        }
        /* */
        
        const results = sendMessage(data);
        results.then((response) => {
            if (typeof document !== `undefined`) {
                document.getElementById("assistant-success").style.display = "block";
            }
        })
        .catch(function (error) {
            if (typeof document !== `undefined`) {
                document.getElementById("assistant-body").style.display = "block";
                alert("Sorry, we couldn't process your request, please try again");
                console.log(error);

            }
        })
        if (typeof document !== `undefined`) {
            document.getElementById("email-loader-container").style.display = "none";
        }
    }

    const detectDevice = () => {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "Tablet";
        }
        else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return "Mobile";
        }
        return "Desktop";
    }
    const clearForm = () => {
        if (typeof document !== `undefined`) {
            document.getElementById("email-loader-container").style.display = "none";
        }
        input_name.current.value = null;
        input_mail.current.value = null;
        input_select.current.value = "";
        input_text.current.value = null;
    }
  return (
    <Fragment>
			<button onClick={()=> {openChat()}} className="sis-email-button" id="sis-email-button" aria-label="Click Here to open Chat" type="button">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_5707_1549)">
                    <path d="M17.78 56.05C18.85 54.05 18.22 52.78 16.64 51.55C12.5805 48.8765 9.28419 45.1952 7.07342 40.8663C4.86266 36.5373 3.81308 31.7087 4.0273 26.8526C4.24152 21.9965 5.71221 17.2791 8.29558 13.1616C10.879 9.04411 14.4866 5.66745 18.7658 3.36177C23.0449 1.05608 27.8492 -0.0997199 32.7089 0.00736849C37.5685 0.114457 42.3172 1.48077 46.4906 3.97272C50.6641 6.46467 54.1195 9.99697 56.519 14.2243C58.9185 18.4516 60.1799 23.2292 60.18 28.09C60.18 36.29 57.65 42.97 52.46 48.53C48.24 53.05 42.28 56.71 34.75 59.41C29.2371 61.3282 23.5398 62.6687 17.75 63.41L13.56 64L17.78 56.05Z" fill="white"/>
                    <path d="M32.0901 2.17001C38.958 2.19111 45.5386 4.92873 50.395 9.78511C55.2513 14.6415 57.989 21.2221 58.0101 28.09C58.0101 35.71 55.6801 41.91 50.8801 47.09C46.8801 51.35 41.2201 54.82 34.0201 57.4C28.6457 59.2713 23.0932 60.5848 17.4501 61.32L19.7001 57.09C20.0718 56.4904 20.3187 55.8219 20.4258 55.1245C20.5329 54.4272 20.4981 53.7154 20.3235 53.0319C20.1489 52.3483 19.838 51.7071 19.4096 51.1466C18.9811 50.5861 18.4439 50.1178 17.8301 49.77C13.1585 46.7088 9.60061 42.2206 7.68636 36.9736C5.77212 31.7267 5.60389 26.0018 7.20673 20.6515C8.80957 15.3012 12.0977 10.6117 16.5815 7.28151C21.0653 3.95129 26.5049 2.15846 32.0901 2.17001" fill="#003D85"/>
                    </g>
                    <path d="M45.7031 16.3125H19.2969C17.6141 16.3125 16.25 17.6766 16.25 19.3594V37.6406C16.25 39.3234 17.6141 40.6875 19.2969 40.6875H45.7031C47.3859 40.6875 48.75 39.3234 48.75 37.6406V19.3594C48.75 17.6766 47.3859 16.3125 45.7031 16.3125ZM45.7031 19.3594V21.9495C44.2799 23.1086 42.0108 24.9108 37.16 28.7092C36.091 29.55 33.9734 31.5702 32.5 31.5466C31.0268 31.5704 28.9086 29.5497 27.84 28.7092C22.9899 24.9114 20.7203 23.1087 19.2969 21.9495V19.3594H45.7031ZM19.2969 37.6406V25.8592C20.7514 27.0178 22.814 28.6435 25.958 31.1053C27.3454 32.1974 29.7751 34.6083 32.5 34.5937C35.2115 34.6083 37.6104 32.2324 39.0415 31.1058C42.1853 28.644 44.2486 27.0179 45.7031 25.8593V37.6406H19.2969Z" fill="#FFFFFF"/>
                    <defs>
                    <clipPath id="clip0_5707_1549">
                    <rect width="56.18" height="64" fill="white" transform="translate(4)"/>
                    </clipPath>
                    </defs>
                </svg>
			</button>

			<div id="email-assistant" className="email-assistant">
                <div id="email-loader-container" className="email-loader-container" >
                    <div id="email-loader"></div>
                </div> 
				<div className="assistant-header">
					<img src={process.env.GATSBY_LOGO} alt={`${process.env.GATSBY_BRAND} ! Your One Stop Money Shop`} title={`${process.env.GATSBY_BRAND} ! Your One Stop Money Shop`} width="35" height="32" />
					<p className="cic-lead--medium assistant-header-title">Email Assistant</p>
					<div className="cic-phone-white-size IconCloseMenu cic-icon-primary assistant-header-close" onClick={()=> {closeChat()}}></div>
				</div>
				<div id="assistant-body" className="assistant-body">
					<h3 className="assistant-title">Have a Question?</h3>
					<p className="assistant-content">Send us a note. We'll get back to you as soon as we can. </p>
					
					<p id='assistant-name-error' className="cic-caption assistant-body-error">Required </p>
					<div className="form-group has-float-label cic-fl-input">
						<input className="form-control" id="assistant-name" type="input" placeholder="Name" ref={input_name}/>
						<label htmlFor="assistant-name">Name</label>
					</div>

					<p id='assistant-email-error' className="cic-caption assistant-body-error">Required </p>
					<div className="form-group has-float-label cic-fl-input">
						<input className="form-control" id="assistant-mail" type="email" placeholder="Email" ref={input_mail}/>
						<label htmlFor="assistant-mail">Email</label>
					</div>

					<p id='assistant-select-error' className="cic-caption assistant-body-error">Required </p>
					<div className="form-group has-float-label has-select cic-fl-input">
                        <select className='select-info' ref={input_select}>
                            <option value="">Select a topic</option>
                            <option>General Loan Information</option>
                            <option>Local Stores and Services</option>
                            <option>Question about My Loan</option>
                            <option>Question about My Application</option>
                            <option>Privacy Information</option>
                            <option>Rates and Fees</option>
                            <option>Pay My Balance</option>
                            <option>Payment Options</option>
                            <option>Other</option> 
                        </select>
						<label htmlFor="assistant-topic">Topic</label>  
					</div> 
					<p id='assistant-text-error' className="cic-caption assistant-body-error">Required </p>
					<div className="form-group has-float-label cic-fl-input">
						<textarea className="form-control" id="assistant-message" rows="1" placeholder="Message" ref={input_text}></textarea>
						<label htmlFor="assistant-message">Message</label>
					</div>

					<button onClick={()=> {validateForm()}} id="assistant-send-message" className="cic-btn cic-btn-primary my-3" aria-label="">Send Message</button>
				</div>
				<div id="assistant-success" className="assistant-success">
					<h3 className="assistant-title">Thank You!</h3>
					<p className="assistant-content">We have received your message! One of our Customer Care Agents will respond as soon as they can via email, typically within 24 hours.</p>
				</div>
			</div>
    </Fragment>
  )
}
